




// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import { motion } from 'framer-motion';
// import Navbar from '../components/Navbar';
// import Footer from '../components/Footer';

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     phone: '',
//     service: '',
//     message: ''
//   });

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     alert('Thank you for contacting Docmize! We will get back to you soon.');
//     setFormData({ firstName: '', lastName: '', email: '', phone: '', service: '', message: '' });
//   };

//   return (
//     <div className="font-['Raleway',sans-serif] bg-white text-gray-900 overflow-x-hidden pt-[90px]">
//       <Navbar />

//       {/* ==================== HERO SECTION ==================== */}
//       <section className="relative min-h-[300px] flex items-center justify-center overflow-hidden">
//         <div 
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage: `url('https://images.unsplash.com/photo-1423666639041-f56000c27a9a?w=1920&q=80')`,
//           }}
//         />
//         <div className="absolute inset-0 bg-[#19354a]/90" />
        
//         <div className="relative z-10 text-center px-6">
//           <motion.h1 
//             initial={{ opacity: 0, y: 30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//             className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8"
//           >
//             Contact Us
//           </motion.h1>
          
//           <motion.div 
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6, delay: 0.2 }}
//             className="flex items-center justify-center gap-4 flex-wrap"
//           >
//             <Link 
//               to="/" 
//               className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all"
//             >
//               Home
//             </Link>
//             <span className="text-white text-2xl">|</span>
//             <span className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold">
//               Contact Us
//             </span>
//           </motion.div>
//         </div>
//       </section>

     
//       {/* ==================== MAP & FORM SECTION ==================== */}
//       <section className="py-16 bg-gray-50">
//         <div className="max-w-7xl mx-auto px-6">
//           <div className="grid lg:grid-cols-2 gap-12">
            
//             {/* Left - Map & Social */}
//             <motion.div
//               initial={{ opacity: 0, x: -50 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               viewport={{ once: true }}
//               transition={{ duration: 0.6 }}
//               className="space-y-8"
//             >
//               {/* Map */}
//               <div className="rounded-2xl overflow-hidden h-[350px] border-2 border-[#19354a]">
//                 <iframe
//                   src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3507.210799341937!2d77.10421631508022!3d28.69276898239562!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d03c8c3c3c3c3%3A0x3c3c3c3c3c3c3c3c!2sSwastik%20Apartment%2C%20Block%20H%20Rd%2C%20Block%20H%2C%20Ashok%20Vihar%2C%20Ashok%20Vihar%20Phase%20II%2C%20Gurugram%2C%20Haryana%20122015!5e0!3m2!1sen!2sin!4v1703345600000"
//                   width="100%"
//                   height="100%"
//                   style={{ border: 0 }}
//                   allowFullScreen=""
//                   loading="lazy"
//                   title="Docmize Location"
//                 ></iframe>
//               </div>

//               {/* Working Hours */}
//               <div className="bg-white rounded-2xl p-6 border-2 border-[#19354a]">
//                 <h3 className="text-xl font-bold text-[#19354a] mb-4 flex items-center gap-2">
//                   <svg className="w-6 h-6 text-[#39a5d3]" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
//                   </svg>
//                   Working Hours
//                 </h3>
//                 <div className="space-y-2 text-gray-600">
//                   <div className="flex justify-between">
//                     <span>Monday - Friday</span>
//                     <span className="font-semibold text-[#19354a]">9:00 AM - 6:00 PM</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span>Saturday</span>
//                     <span className="font-semibold text-[#19354a]">10:00 AM - 4:00 PM</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span>Sunday</span>
//                     <span className="font-semibold text-[#39a5d3]">Closed</span>
//                   </div>
//                 </div>
//               </div>

             
              
//             </motion.div>

//             {/* Right - Form */}
//             <motion.div
//               initial={{ opacity: 0, x: 50 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               viewport={{ once: true }}
//               transition={{ duration: 0.6, delay: 0.2 }}
//             >
//               <div className="bg-white rounded-2xl p-8 border-2 border-[#19354a] shadow-lg">
//                 <h2 className="text-2xl font-bold text-[#19354a] mb-2">
//                   Send Us a <span className="text-[#39a5d3]">Message</span>
//                 </h2>
//                 <p className="text-gray-600 mb-6">
//                   We'll get back to you within 24 hours!
//                 </p>

//                 <form onSubmit={handleSubmit} className="space-y-5">
//                   {/* Name Fields */}
//                   <div className="grid sm:grid-cols-2 gap-4">
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-1">First Name *</label>
//                       <input
//                         type="text"
//                         required
//                         value={formData.firstName}
//                         onChange={(e) => setFormData({...formData, firstName: e.target.value})}
//                         className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 outline-none focus:border-[#39a5d3] transition-colors"
//                         placeholder="John"
//                       />
//                     </div>
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-1">Last Name *</label>
//                       <input
//                         type="text"
//                         required
//                         value={formData.lastName}
//                         onChange={(e) => setFormData({...formData, lastName: e.target.value})}
//                         className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 outline-none focus:border-[#39a5d3] transition-colors"
//                         placeholder="Doe"
//                       />
//                     </div>
//                   </div>

//                   {/* Email & Phone */}
//                   <div className="grid sm:grid-cols-2 gap-4">
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
//                       <input
//                         type="email"
//                         required
//                         value={formData.email}
//                         onChange={(e) => setFormData({...formData, email: e.target.value})}
//                         className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 outline-none focus:border-[#39a5d3] transition-colors"
//                         placeholder="john@example.com"
//                       />
//                     </div>
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-1">Phone *</label>
//                       <input
//                         type="tel"
//                         required
//                         value={formData.phone}
//                         onChange={(e) => setFormData({...formData, phone: e.target.value})}
//                         className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 outline-none focus:border-[#39a5d3] transition-colors"
//                         placeholder="+91 8920845297"
//                       />
//                     </div>
//                   </div>

//                   {/* Service Select */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Select Service</label>
//                     <select
//                       value={formData.service}
//                       onChange={(e) => setFormData({...formData, service: e.target.value})}
//                       className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 outline-none focus:border-[#39a5d3] transition-colors cursor-pointer"
//                     >
//                       <option value="">Choose a service...</option>
//                       <option value="SEO for Doctors">SEO for Doctors</option>
//                       <option value="Google Ads for Doctors">Google Ads for Doctors</option>
//                       <option value="Social Media Management">Social Media Management</option>
//                       <option value="Website Development">Website Development</option>
//                       <option value="Lead Management">Lead Management</option>
//                       <option value="Patient Communication">Patient Communication & Analytics</option>
//                       <option value="Creative & Branding">Creative, Media & Branding</option>
//                       <option value="Other">Other</option>
//                     </select>
//                   </div>

//                   {/* Message */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Message *</label>
//                     <textarea
//                       rows="4"
//                       required
//                       value={formData.message}
//                       onChange={(e) => setFormData({...formData, message: e.target.value})}
//                       className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 outline-none focus:border-[#39a5d3] transition-colors resize-none"
//                       placeholder="Tell us about your practice and how we can help..."
//                     />
//                   </div>

//                   {/* Submit Button */}
//                   <motion.button
//                     type="submit"
//                     whileHover={{ scale: 1.02 }}
//                     whileTap={{ scale: 0.98 }}
//                     className="w-full py-4 rounded-lg font-bold text-white bg-[#19354a] hover:bg-[#0f2133] transition-all"
//                   >
//                     Send Message
//                   </motion.button>
//                 </form>
//               </div>
//             </motion.div>

//           </div>
//         </div>
//       </section>


//        {/* ==================== CONTACT INFO CARDS ==================== */}
//       <section className="py-16 bg-white">
//         <div className="max-w-7xl mx-auto px-6">
//           <div className="grid md:grid-cols-3 gap-6 mb-16">
            
//             {/* Card 1 - Address */}
//             <motion.div
//               initial={{ opacity: 0, y: 30 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//               className="bg-white rounded-2xl p-8 border-2 border-[#19354a] text-center hover:shadow-xl transition-all"
//             >
//               <div className="w-16 h-16 bg-[#19354a] rounded-full flex items-center justify-center mx-auto mb-4">
//                 <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
//                   <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
//                 </svg>
//               </div>
//               <h3 className="text-xl font-bold text-[#19354a] mb-2">Our Office</h3>
//               <p className="text-gray-600">
//                 Swastik Appartment, Block H Rd,<br />
//                 Block H, Ashok Vihar,<br />
//                 Ashok Vihar Phase II,<br />
//                 Gurugram, Haryana 122015
//               </p>
//             </motion.div>

//             {/* Card 2 - Phone */}
//             <motion.div
//               initial={{ opacity: 0, y: 30 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ duration: 0.5, delay: 0.2 }}
//               className="bg-white rounded-2xl p-8 border-2 border-[#19354a] text-center hover:shadow-xl transition-all"
//             >
//               <div className="w-16 h-16 bg-[#19354a] rounded-full flex items-center justify-center mx-auto mb-4">
//                 <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
//                 </svg>
//               </div>
//               <h3 className="text-xl font-bold text-[#19354a] mb-2">Call Us</h3>
//               <a href="tel:+918920845297" className="text-gray-600 hover:text-[#39a5d3] transition-colors">
//                 +91 8920845297
//               </a>
//             </motion.div>

//             {/* Card 3 - Email */}
//             <motion.div
//               initial={{ opacity: 0, y: 30 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ duration: 0.5, delay: 0.3 }}
//               className="bg-white rounded-2xl p-8 border-2 border-[#19354a] text-center hover:shadow-xl transition-all"
//             >
//               <div className="w-16 h-16 bg-[#19354a] rounded-full flex items-center justify-center mx-auto mb-4">
//                 <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
//                 </svg>
//               </div>
//               <h3 className="text-xl font-bold text-[#19354a] mb-2">Email Us</h3>
//               <a href="mailto:mail@docmize.com" className="text-gray-600 hover:text-[#39a5d3] transition-colors">
//                 mail@docmize.com
//               </a>
//             </motion.div>

//           </div>
//         </div>
//       </section>


//       {/* ==================== CTA SECTION ==================== */}
//       <section className="py-16 bg-gray-50">
//         <div className="max-w-4xl mx-auto px-6 text-center">
//           <motion.h2 
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.6 }}
//             className="text-3xl lg:text-4xl font-bold text-[#19354a] mb-6"
//           >
//             Ready to Grow Your Medical Practice?
//           </motion.h2>
//           <motion.p 
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.6, delay: 0.1 }}
//             className="text-gray-600 text-lg mb-8"
//           >
//             Let's discuss how we can help attract more patients and grow your healthcare practice with our specialized Growth Ecosystem solutions.
//           </motion.p>
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.6, delay: 0.2 }}
//             className="flex flex-col sm:flex-row gap-4 justify-center"
//           >
//             <a 
//               href="tel:+918920845297" 
//               className="px-8 py-4 bg-[#19354a] text-white rounded-lg font-semibold hover:bg-[#0f2133] transition-all flex items-center justify-center gap-2"
//             >
//               <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
//               </svg>
//               Call Us Now
//             </a>
//             <a 
//               href="mailto:mail@docmize.com" 
//               className="px-8 py-4 border-2 border-[#19354a] text-[#19354a] rounded-lg font-semibold hover:bg-[#19354a] hover:text-white transition-all flex items-center justify-center gap-2"
//             >
//               <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
//               </svg>
//               Email Us
//             </a>
//           </motion.div>
//         </div>
//       </section>

//       <Footer />
//     </div>
//   );
// };

// export default Contact;

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const response = await fetch('http://localhost:5000/api/contact/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.success) {
        setShowSuccessMessage(true);
        setFormData({ 
          firstName: '', 
          lastName: '', 
          email: '', 
          phone: '', 
          service: '', 
          message: '' 
        });
        
        // Auto hide success message after 5 seconds
        setTimeout(() => setShowSuccessMessage(false), 5000);
      } else {
        setShowErrorMessage(true);
        setTimeout(() => setShowErrorMessage(false), 5000);
      }
    } catch (error) {
      console.error('Error:', error);
      setShowErrorMessage(true);
      setTimeout(() => setShowErrorMessage(false), 5000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="font-['Raleway',sans-serif] bg-white text-gray-900 overflow-x-hidden pt-[90px]">
      <Navbar />

      {/* HERO SECTION */}
      <section className="relative min-h-[300px] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1423666639041-f56000c27a9a?w=1920&q=80')`,
          }}
        />
        <div className="absolute inset-0 bg-[#19354a]/90" />
        
        <div className="relative z-10 text-center px-6">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8"
          >
            Contact Us
          </motion.h1>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center justify-center gap-4 flex-wrap"
          >
            <Link 
              to="/" 
              className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all"
            >
              Home
            </Link>
            <span className="text-white text-2xl">|</span>
            <span className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold">
              Contact Us
            </span>
          </motion.div>
        </div>
      </section>

      {/* MAP & FORM SECTION */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12">
            
            {/* Left - Map & Working Hours */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="space-y-8"
            >
              {/* Map */}
            {/* Map with Get Directions Button */}
<div className="rounded-2xl overflow-hidden h-[350px] border-2 border-[#19354a] relative">
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.956789!2d77.0147381!3d28.4897609!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2a8ed6c3d8fdbcbf%3A0xe3e39996315bc6d2!2sDocmize%20Solutions%20Private%20Limited!5e0!3m2!1sen!2sin!4v1738483200000!5m2!1sen!2sin"
    width="100%"
    height="100%"
    style={{ border: 0 }}
    allowFullScreen=""
    loading="lazy"
    title="Docmize Location"
  ></iframe>
  
  {/* Directions Button Overlay */}
  <a 
    href="https://www.google.com/maps/dir//Docmize+Solutions+Private+Limited,+Swastik+Appartment,+Block+H+Rd,+Block+H,+Ashok+Vihar,+Ashok+Vihar+Phase+II,+Gurugram,+Haryana+122015/@28.4897609,77.0169381"
    target="_blank"
    rel="noopener noreferrer"
    className="absolute bottom-4 right-4 bg-[#39a5d3] hover:bg-[#2a8db8] text-white px-4 py-2 rounded-lg font-semibold shadow-lg transition-all flex items-center gap-2"
  >
    <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z" />
    </svg>
    Get Directions
  </a>
</div>
              {/* Working Hours */}
              <div className="bg-white rounded-2xl p-6 border-2 border-[#19354a]">
                <h3 className="text-xl font-bold text-[#19354a] mb-4 flex items-center gap-2">
                  <svg className="w-6 h-6 text-[#39a5d3]" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  Working Hours
                </h3>
                <div className="space-y-2 text-gray-600">
                  <div className="flex justify-between">
                    <span>Monday - Friday</span>
                    <span className="font-semibold text-[#19354a]">9:00 AM - 6:00 PM</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Saturday</span>
                    <span className="font-semibold text-[#19354a]">10:00 AM - 4:00 PM</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Sunday</span>
                    <span className="font-semibold text-[#39a5d3]">Closed</span>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Right - Contact Form */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <div className="bg-white rounded-2xl p-8 border-2 border-[#19354a] shadow-lg">
                <h2 className="text-2xl font-bold text-[#19354a] mb-2">
                  Send Us a <span className="text-[#39a5d3]">Message</span>
                </h2>
                <p className="text-gray-600 mb-6">
                  We'll get back to you within 24 hours!
                </p>

                <form onSubmit={handleSubmit} className="space-y-5">
                  {/* Name Fields */}
                  <div className="grid sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">First Name *</label>
                      <input
                        type="text"
                        required
                        value={formData.firstName}
                        onChange={(e) => setFormData({...formData, firstName: e.target.value})}
                        className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 outline-none focus:border-[#39a5d3] transition-colors"
                        placeholder="John"
                        disabled={isSubmitting}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Last Name *</label>
                      <input
                        type="text"
                        required
                        value={formData.lastName}
                        onChange={(e) => setFormData({...formData, lastName: e.target.value})}
                        className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 outline-none focus:border-[#39a5d3] transition-colors"
                        placeholder="Doe"
                        disabled={isSubmitting}
                      />
                    </div>
                  </div>

                  {/* Email & Phone */}
                  <div className="grid sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
                      <input
                        type="email"
                        required
                        value={formData.email}
                        onChange={(e) => setFormData({...formData, email: e.target.value})}
                        className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 outline-none focus:border-[#39a5d3] transition-colors"
                        placeholder="john@example.com"
                        disabled={isSubmitting}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Phone *</label>
                      <input
                        type="tel"
                        required
                        value={formData.phone}
                        onChange={(e) => setFormData({...formData, phone: e.target.value})}
                        className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 outline-none focus:border-[#39a5d3] transition-colors"
                        placeholder="+91 8920845297"
                        disabled={isSubmitting}
                      />
                    </div>
                  </div>

                  {/* Service Select */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Select Service</label>
                    <select
                      value={formData.service}
                      onChange={(e) => setFormData({...formData, service: e.target.value})}
                      className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 outline-none focus:border-[#39a5d3] transition-colors cursor-pointer"
                      disabled={isSubmitting}
                    >
                      <option value="">Choose a service...</option>
                      <option value="SEO for Doctors">SEO for Doctors</option>
                      <option value="Google Ads for Doctors">Google Ads for Doctors</option>
                      <option value="Social Media Management">Social Media Management</option>
                      <option value="Website Development">Website Development</option>
                      <option value="Lead Management">Lead Management</option>
                      <option value="Patient Communication">Patient Communication & Analytics</option>
                      <option value="Creative & Branding">Creative, Media & Branding</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>

                  {/* Message */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Message *</label>
                    <textarea
                      rows="4"
                      required
                      value={formData.message}
                      onChange={(e) => setFormData({...formData, message: e.target.value})}
                      className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 outline-none focus:border-[#39a5d3] transition-colors resize-none"
                      placeholder="Tell us about your practice and how we can help..."
                      disabled={isSubmitting}
                    />
                  </div>

                  {/* Submit Button */}
                  <motion.button
                    type="submit"
                    disabled={isSubmitting}
                    whileHover={{ scale: isSubmitting ? 1 : 1.02 }}
                    whileTap={{ scale: isSubmitting ? 1 : 0.98 }}
                    className={`w-full py-4 rounded-lg font-bold text-white transition-all ${
                      isSubmitting 
                        ? 'bg-gray-400 cursor-not-allowed' 
                        : 'bg-[#19354a] hover:bg-[#0f2133]'
                    }`}
                  >
                    {isSubmitting ? 'Sending...' : 'Send Message'}
                  </motion.button>
                </form>
              </div>
            </motion.div>

          </div>
        </div>
      </section>

      {/* CONTACT INFO CARDS */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-6">
            
            {/* Address */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="bg-white rounded-2xl p-8 border-2 border-[#19354a] text-center hover:shadow-xl transition-all"
            >
              <div className="w-16 h-16 bg-[#19354a] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-[#19354a] mb-2">Our Office</h3>
              <p className="text-gray-600 text-sm">
                Swastik Appartment, Block H Rd,<br />
                Block H, Ashok Vihar,<br />
                Ashok Vihar Phase II,<br />
                Gurugram, Haryana 122015
              </p>
            </motion.div>

            {/* Phone */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="bg-white rounded-2xl p-8 border-2 border-[#19354a] text-center hover:shadow-xl transition-all"
            >
              <div className="w-16 h-16 bg-[#19354a] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-[#19354a] mb-2">Call Us</h3>
              <a href="tel:+918920845297" className="text-gray-600 hover:text-[#39a5d3] transition-colors">
                +91 8920845297
              </a>
            </motion.div>

            {/* Email */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="bg-white rounded-2xl p-8 border-2 border-[#19354a] text-center hover:shadow-xl transition-all"
            >
              <div className="w-16 h-16 bg-[#19354a] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-[#19354a] mb-2">Email Us</h3>
              <a href="mailto:mail@docmize.com" className="text-gray-600 hover:text-[#39a5d3] transition-colors">
                mail@docmize.com
              </a>
            </motion.div>

          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <motion.h2 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-3xl lg:text-4xl font-bold text-[#19354a] mb-6"
          >
            Ready to Grow Your Medical Practice?
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-gray-600 text-lg mb-8"
          >
            Let's discuss how we can help attract more patients and grow your healthcare practice.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <a 
              href="tel:+918920845297" 
              className="px-8 py-4 bg-[#19354a] text-white rounded-lg font-semibold hover:bg-[#0f2133] transition-all flex items-center justify-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
              </svg>
              Call Us Now
            </a>
            <a 
              href="mailto:mail@docmize.com" 
              className="px-8 py-4 border-2 border-[#19354a] text-[#19354a] rounded-lg font-semibold hover:bg-[#19354a] hover:text-white transition-all flex items-center justify-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
              </svg>
              Email Us
            </a>
          </motion.div>
        </div>
      </section>

      {/* Success Message Toast */}
      <AnimatePresence>
        {showSuccessMessage && (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
            className="fixed bottom-8 right-8 z-50 max-w-md"
          >
            <div className="bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-4 rounded-xl shadow-2xl flex items-start gap-4">
              <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="3">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <div className="flex-1">
                <h4 className="font-bold text-lg mb-1">✅ Message Sent Successfully!</h4>
                <p className="text-sm text-white/90">
                  Thank you for contacting us! We'll get back to you within 24 hours.
                </p>
              </div>
              <button 
                onClick={() => setShowSuccessMessage(false)}
                className="text-white/80 hover:text-white transition-colors"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Error Message Toast */}
      <AnimatePresence>
        {showErrorMessage && (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
            className="fixed bottom-8 right-8 z-50 max-w-md"
          >
            <div className="bg-gradient-to-r from-red-500 to-red-600 text-white px-6 py-4 rounded-xl shadow-2xl flex items-start gap-4">
              <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div className="flex-1">
                <h4 className="font-bold text-lg mb-1">⚠️ Submission Failed</h4>
                <p className="text-sm text-white/90">
                  Something went wrong. Please try again or call us at +91 8920845297.
                </p>
              </div>
              <button 
                onClick={() => setShowErrorMessage(false)}
                className="text-white/80 hover:text-white transition-colors"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <Footer />
    </div>
  );
};

export default Contact;